import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

export type FilterStoreState<T> = {
  data: T | null;
  save: (data: T) => void;
  load: () => T | null;
};

export const getFilterStore = <T>(storeName: string) =>
  create(
    persist(
      immer<FilterStoreState<T>>((set, get) => {
        return {
          data: null,
          load: () => get().data,
          save: (data: T) => set({ data }),
        };
      }),
      {
        name: storeName,
        storage: createJSONStorage(() => {
          return {
            setItem: localStorage.setItem.bind(localStorage),
            removeItem: localStorage.removeItem.bind(localStorage),
            getItem: localStorage.getItem.bind(localStorage),
          };
        }),
      },
    ),
  );

export type FiltersStore<T = unknown> = ReturnType<typeof getFilterStore<T>>;
